<template>
  <section class="grid">

      <section class="card">
        <section class="title">
          <h3><i class="icon-programme"></i>PROGRAMMES {{ year }}</h3>
          <p>
            <em class="info">Statistiques basées sur les réservations effectuées en {{ year }}.</em>
          </p>
        </section>

        <section class="grid">
          <section class="card">
            <small>Liste des programmes retenus</small>
            <ul>
              <li class="badge verysmall">{{programsList.length}} Programmes</li>
              <li v-if="region < 0" class="badge verysmall small">(dont {{programsRegion.length}} en métropole)</li>
            </ul>
            <p class="verysmall">
              <i class="blue round">*</i>En commercialisation <i class="red round">*</i>Vendu ou livré <i class="orange round">*</i>Non publié
            </p>
            <ul class="verysmall">
              <li class="center" v-for="(prog, p) in programsList" :key="p"><div class="round small">{{ prog.delivery | yearDate }}</div><div class="round" :class="{'orange' : prog.status === 0, 'blue' : prog.status === 1, 'red' : prog.status === 2}">{{ prog.name }}</div></li>
            </ul>
            <hr/>
            <small>Nombre de lots retenus</small>
            <ul>
              <li class="badge verysmall">{{lotsCustom.length}} Lots</li>
              <li v-if="region < 0" class="badge verysmall small">(dont {{lotsRegion.length}} en métropole)</li>
            </ul>
            <p>
              <label for="tva">
                <input type="checkbox" class="toggle" id="tva" v-model="tva" />
                📊 Afficher les valeurs sur la base du prix HT calculé.
              </label>
            </p>
            <p>
              <label for="available">
                <input type="checkbox" class="toggle" id="available" v-model="available" />
                🗝️ Inclure les lots disponibles à la vente des programmes concernés.
              </label>
            </p>
            <p class="small">
              <label for="legacy">
                <input type="checkbox" class="toggle" id="legacy" v-model="legacy" />
                📈 Afficher le récapitulatif des données par statut et par type (ancienne version).
              </label>
            </p>
            <div class="new">
              <p>
                <select id="region" v-model="region" autocomplete="off">
                  <option value="-1">Régions: Toutes</option>
                  <option v-for="(region, r) in settings.program.region" :value="r" :key="r">{{ region }}</option>
                </select>
                <i class="icon-select"></i>
                <select id="year" v-model.number="year">
                  <option v-for="ye in yearsList" :key="ye" :value="ye"> {{ ye }}</option>
                </select>
                <i class="icon-select"></i>
                <select id="term" v-model="term">
                  <option value="-1">Trimestres: Tous</option>
                  <option v-for="(term, t) in settings.stat.term" :value="t" :key="t">{{ term }}</option>
                </select>
                <i class="icon-select"></i>
              </p>
            </div>
          </section>
        </section>

        <section class="grid add stats" v-if="legacy">

          <section class="card">
            <small>Stats réservations par status</small>
            <Status v-bind:numero="selectedprograms" v-bind:customlots="lotsCustom"/>
          </section>

          <section class="card">
            <small>Stats réservations par types</small>
            <Type v-bind:numero="selectedprograms" v-bind:customlots="lotsCustom"/>
          </section>

        </section>

        <section class="grid add stats">

          <section class="card">
            <small>Stats réservations par programmes</small>
            <small class="verysmall">(Basé sur les lots <i style="color: var(--reserved);">⬤</i> réservés, <i style="color: var(--financed);">⬤</i> financés et <i style="color: var(--acted);">⬤</i> actés)</small>
            <Prog v-bind:customReservations="reservationsCustom" v-bind:listPrograms="programs" v-bind:tva="tva"/>
          </section>

          <section class="card">
            <small>Stats réservations par dispositifs</small>
            <small class="verysmall">(basé sur les lots <i style="color: var(--reserved);">⬤</i> réservés, <i style="color: var(--financed);">⬤</i> financés et <i style="color: var(--acted);">⬤</i> actés)</small>
            <law v-bind:customReservations="reservationsCustom" v-bind:tva="tva"/>
          </section>

          <section class="card">
            <small>Stats réservations par période</small>
            <p class="small">
              <label for="showprice">
                <input type="checkbox" class="toggle" id="showprice" v-model="showprice" />
                💰 Afficher le montant cumulé.
              </label>
            </p>
            <Period v-bind:customReservations="reservationsCustom" v-bind:showprice="showprice" v-bind:tva="tva"/>
          </section>

        </section>

        <section class="grid">

          <section class="card">
            <small>Stats réservations mixtes</small>
            <Full v-bind:numero="selectedprograms" v-bind:customlots="lotsCustom"/>
          </section>

          <section class="card">
            <small>Stats réservations par partenaires</small>
            <small class="verysmall">(Les lots <i style="color: var(--grey-dark);">⬤</i> annulés <em v-if="!optionned">et <i style="color: var(--yellow);">⬤</i> optionnés</em> ne sont pas comptabilisés dans le total)</small>
            <p>
              <label for="optionned">
                <input type="checkbox" class="toggle" id="optionned" v-model="optionned" />
                🔑 Inclure les lots optionnés dans le total.
              </label>
            </p>
            <Partner v-bind:numero="selectedprograms" v-bind:customlots="lotsCustom" v-bind:option="optionned" v-bind:customReservations="reservationsCustom" v-bind:tva="tva" />
          </section>

        </section>

        <hr/>

        <div class="new">
          <p>
            <label>Limite d'affichage:
              <select id="limitprogram" v-model="limitprogram">
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
              <i class="icon-select"></i>
            </label>
          </p>
        </div>

        <section class="grid add">
          <section class="card">
            <section class="table by3">
              <small>Top des visites (programme)</small>
              <ul>
                <li><label>NOMBRE</label><label>PROGRAMME</label><label>DAT</label></li>
              </ul>
              <ul>
                <li v-for="(prog, p) in programsclick" :key="p">
                  <span class="bold">{{ prog.stats.click }}</span>
                  <span> {{ prog.name }}</span>
                  <span> {{ prog.dat | shortDate }}</span>
                </li>
              </ul>
            </section>
          </section>

          <section class="card">
            <section class="table by5">
              <small>Top des téléchargement (lots)</small>
              <ul>
                <li><label>NOMBRE</label><label>PROGRAMME</label><label>NUMERO</label><label>TYPE</label><label>PRIX</label></li>
              </ul>
              <ul>
                <li v-for="(lot, p) in lotsclick" :key="p">
                  <span class="bold">{{ lot.stats.click }}</span>
                  <span>{{ lot.program.shortname }}</span>
                  <span>{{ lot.numero }}</span>
                  <span>{{ lot.spec.type | type }}</span>
                  <span>{{ lot.spec.price }} €</span>
                </li>
              </ul>
            </section>
          </section>

        </section>

      </section>
    </section>
</template>

<script>
import Status from '@/components/StatisticsProgramStatus.vue'
import Type from '@/components/StatisticsProgramType.vue'
import Period from '@/components/StatisticsProgramPeriod.vue'
import law from '@/components/StatisticsProgramLaw.vue'
import Prog from '@/components/StatisticsProgramProg.vue'
import Full from '@/components/StatisticsProgramFull.vue'
import Partner from '@/components/StatisticsProgramPartner.vue'
import settings from '@/settings.js'

export default {
  name: 'StatisticsPrograms',
  components: {
    Status,
    Type,
    Period,
    law,
    Prog,
    Full,
    Partner
  },
  data () {
    return {
      settings,
      limitprogram: 5,
      statusprogram: 1,
      dateprogram: 0,
      selectedprograms: -1,
      region: -1,
      term: -1,
      legacy: false,
      available: false,
      tva: true,
      showprice: false,
      optionned: false,
      year: new Date().getFullYear()
    }
  },
  computed: {
    programs: function () {
      return this.$store.getters.get_programs()
    },
    programsList: function () {
      // filter programs to only those with lots/reservations this year
      var filteredList = this.lotsCustom.map(l => l.program.numero)
      var progs = this.programs.filter(p => filteredList.includes(p.numero))
      if (this.region > -1) {
        return progs.filter(p => p.location.region === this.region)
      }
      return progs
    },
    programsRegion: function () {
      return this.programsList.filter(p => p.location.region === 0)
    },
    programsclick: function () {
      return this.programs.slice().sort(function (a, b) {
        return (a.stats.click < b.stats.click) ? 1 : -1
      }).slice(0, this.limitprogram)
    },
    lots: function () {
      return this.$store.getters.get_lots()
    },
    lotsCustom: function () {
      var custom = this.lots.filter(l => {
        return this.reservationsCustom.find(r => r.lot.uid === l.uid && r.status > 0)
      }).map(l => {
        const reservation = this.reservationsCustom.find(r => r.lot.uid === l.uid && r.status > 0)
        if (reservation) {
          return {
            ...l,
            spec: {
              ...l.spec,
              price: this.tva ? (Number(reservation.lot.calculatedprice) || 0) : (Number(reservation.lot.actedprice) || 0)
            }
          }
        }
        return l
      })
      if (!this.available) return custom
      const programs = [...new Set(custom.map(l => l.program.numero))]
      var availableLots = this.lots.filter(l => programs.includes(l.program.numero) && l.status === 0)
      if (this.tva) {
        return custom.concat(availableLots.map(l => {
          const prog = this.programs.find(p => p.numero === l.program.numero)
          const spec = Object.assign({}, l.spec)
          if (prog.location.region === 0) {
            spec.price = Math.round((Number(l.spec.price) / (1 + 20 / 100)) * 100) / 100
          }
          return Object.assign({}, l, { spec })
        }))
      }
      return custom.concat(availableLots)
    },
    lotsRegion: function () {
      return this.lotsCustom.filter(l => {
        return this.programs.find(p => p.numero === l.program.numero && p.location.region === 0)
      })
    },
    lotsclick: function () {
      var LOTS = this.lotsCustom
      return LOTS.slice().sort(function (a, b) {
        return (a.stats.click < b.stats.click) ? 1 : -1
      }).slice(0, this.limitprogram)
    },
    reservations: function () {
      return this.$store.getters.get_reservations_by_year(Number(this.year))
    },
    reservationsPeriod: function () {
      if (this.term > -1) {
        var startMonth = this.term * 3
        var endMonth = startMonth + 3
        const statusDateFields = ['datecancel', 'dateoption', 'datereserv', 'datefinanced', 'dateacted']
        return this.reservations.filter(r => {
          const status = Number(r.status)
          const dateField = statusDateFields[status]
          var dateValue = r.lot[dateField]
          if (status === 4) dateValue = r.notary.signdate
          var resDate = new Date(dateValue)
          var resMonth = resDate.getMonth()
          return resMonth >= startMonth && resMonth < endMonth
        })
      }
      return this.reservations
    },
    reservationsCustom: function () {
      if (this.region > -1) {
        return this.reservationsPeriod.filter(r => {
          return this.programs.find(p => p.numero === r.program.numero && p.location.region === this.region)
        })
      }
      return this.reservationsPeriod
    },
    yearsList: function () {
      const years = []
      for (let i = new Date().getFullYear(); i >= 2020; i--) {
        years.push(i)
      }
      return years
    }
  },
  methods: {
  }
}
</script>
